export default "__VITE_ASSET__77cf16d7__"